<template>
  <div class="grid p-fluid animate__animated animate__fadeIn">
    <div class="col-12">
      <div class="card card-w-title">
        <div class="card grid shadow-2 mt-3 p-0">
          <div class="field col-12 md:col-3">
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText type="text" v-model="fullName" placeholder="جستجو (نام)" />
            </span>
          </div>
          <div class="field col-12 md:col-3">
            <span class="p-input-icon-left">
              <i v-if="!FromDate" style="font-size: 1.5rem" class="pi pi-calendar" />
              <i v-else @click="FromDate = null" style="font-size: 1.5rem" class="pi pi-calendar-times cursor-pointer" />
              <InputText dir="rtl" v-model="FromDateInput" type="text" id="fromCalendarInputId" placeholder="از تاریخ" />
            </span>
            <custom-date-picker auto-submit v-model="FromDate" :max="currentDate" format="YYYY-MM-DD" display-format="jYYYY/jMM/jDD" custom-input="#fromCalendarInputId" />
          </div>
          <div class="field col-12 md:col-3">
            <span class="p-input-icon-left">
              <i v-if="!ToDate" style="font-size: 1.5rem" class="pi pi-calendar" />
              <i v-else @click="ToDate = null" style="font-size: 1.5rem" class="pi pi-calendar-times cursor-pointer" />
              <InputText  dir="rtl" v-model="ToDateInput" type="text" id="toCalendarInputId" placeholder="تا تاریخ" />
            </span>
            <custom-date-picker auto-submit v-model="ToDate" :disabled="!FromDate" :max="currentDate" :min="FromDate" format="YYYY-MM-DD" display-format="jYYYY/jMM/jDD" custom-input="#toCalendarInputId" />
          </div>
          <div class="field col-12 md:col-1">
            <Button label="اعمال فیلتر" class="md:w-10rem" :loading="isLoading" @click="serchName" />
          </div>
        </div>
        <div>
          <DataTable :value="feedbacks" :rows="10" :loading="loading.getData" class="overflow-hidden border-round-2xl shadow-1 mt-5 animate__animated animate__fadeIn" responsiveLayout="scroll">
            <Column field="fullName" headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small class="p-column-title">نام و نام خانوادگی</small>
              </template>
              <template #body="slotProps">
                {{ slotProps.data.fullName }}
              </template>
            </Column>
            <Column field="message">
              <template #header>
                <small class="p-column-title">نظر کاربر</small>
              </template>
              <template #body="slotProps">
                {{ slotProps.data.message }}
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small class="p-column-title">وضعیت پاسخ</small>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.replys.length % 2 != 0" class="text-green-500">بررسی شده </span>
                <span v-if="slotProps.data.replys.length % 2 == 0" class="text-red-500">منتظر بررسی</span>
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small class="p-column-title">وضعیت تایید</small>
              </template>
              <template #body="slotProps">
                <Button v-if="slotProps.data.isAccepted" icon="pi pi-check" v-tooltip.top="'رد کردن'" class="p-button-rounded p-button-success mt-2 mr-2" @click="checkComments(slotProps.data.id, false)" />
                <Button v-if="!slotProps.data.isAccepted" icon="pi pi-times" v-tooltip.top="'تایید'" class="p-button-rounded p-button-danger mt-2 mr-2" @click="checkComments(slotProps.data.id, true)" />
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small class="p-column-title">پاسخ</small>
              </template>
              <template #body="slotProps">
                <Button icon="pi pi-pencil" v-tooltip.top="'پاسخ'" class="p-button-rounded p-button-secondary ml-2" @click="editFeature(slotProps.data.id)" />
                <Button icon="pi pi-trash" v-tooltip.top="'حذف'" class="p-button-rounded p-button-warning mt-2" @click="(display = true), (idDelete = slotProps.data.id)" />
              </template>
            </Column>
          </DataTable>
          <Paginator v-if="feedbacks.length" :rows="pageSize" :totalRecords="totalCount" @page="changePaging($event)"></Paginator>
          <div v-if="!feedbacks.length" class="flex justify-content-center mt-4">نظری وجود ندارد</div>
        </div>
        <Dialog v-model:visible="display" :style="{ width: '450px' }" header="حذف" :modal="true">
          <div class="flex flex-column align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle" style="font-size: 4rem" />
            <span class="mt-3">آیا مطمئن هستید؟</span>
          </div>
          <template #footer>
            <div class="text-center">
              <Button label="خیر" icon="pi pi-times" class="p-button-text" @click="display = false" />
              <Button label="بلی" icon="pi pi-check" class="p-button-text" @click="(display = false), confirmDeleteFeedback(idDelete)" />
            </div>
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: {
        getData: false,
      },
      idDelete: null,
      display: false,
      placeId: null,
      columns: null,
      feedbacks: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 1,
      pageCount: 1,
      FromDate: "",
      ToDate: "",
      fullName: "",
    };
  },
  methods: {
    editFeature(id) {
      this.$router.push(`/place/feedback/${id}/response/${this.placeId}`);
    },
    async confirmDeleteFeedback(id) {
      const { status, data } = await this.axios({ method: "delete", url: `/place/${this.placeId}/feedback/${id}/Delete` });
      if (status == 200) {
        const feedback = this.feedbacks.filter((item) => {
          return item.id != id;
        });
        this.feedbacks = feedback;
        this.showToast(status, data.errors);
      }
    },
    async checkComments(id, flag) {
      const { status, data } = await this.axios({
        method: "put",
        url: `/place/${this.placeId}/feedback/${id}/Accept`,
        data: {
          isAccept: flag,
        },
      });
      if (status == 200) {
        this.feedbacks.forEach((item) => {
          if (item.id == id) {
            item.isAccepted = !item.isAccepted;
          }
        });
        this.showToast(status, data.errors);
      }
    },
    changePaging(e) {
      this.getData(++e.page);
    },
    async getData(page = 1) {
      this.loading.getData = true;
      const params = {
        PageIndex: page,
        PageSize: this.pageSize,
        from: this.from,
        to: this.to,
        UserName: this.fullName,
      };
      const { status, data } = await this.axios({ method: "get", url: `/Place/${this.placeId}/feedback?PageIndex=${page}&PageSize=${this.pageSize}&from=${this.FromDate}&to=${this.ToDate}&UserName=${this.fullName}` });
      if (status === 200) {
        this.pageSize = Number(data.pageSize);
        this.pageIndex = data.pageIndex;
        this.totalCount = Number(data.totalCount);
        this.pageCount = +data.pageCount;
        this.feedbacks = [...data.data];
        setTimeout(() => {
          this.loading.getData = false;
        }, 500);
      }
    },
    serchName() {
      this.getData(this.pageIndex);
    },
  },
  mounted() {
    this.placeId = this.$route.params.place_id;
    this.getData();
  },
};
</script>

<style></style>
